const numberFormat = new Intl.NumberFormat('en-GB')

export function formatNumber(value) {
    if (value === null || value === undefined) return '—'
    return numberFormat.format(value)
}

export function formatDuration(ms) {
    if (ms === null || ms === undefined) return '—'
    const seconds = Math.round(ms / 1000)
    if (seconds < 60) return `${seconds}s`
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return `${minutes}m`
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return `${hours}h ${minutes % 60}m`
    const days = Math.floor(hours / 24)
    return `${days}d ${hours % 24}h`
}

export function formatPercent(value) {
    if (value === null || value === undefined) return '—'
    if (value > 0 && value < 1) return '<1%'
    return `${Math.round(value)}%`
}

export function formatDelta(percent, { lowerIsBetter = false } = {}) {
    if (percent === null || percent === undefined) return null
    const rising = percent > 0
    const good = lowerIsBetter ? !rising : rising
    return {
        text: `${rising ? '▲' : '▼'} ${Math.abs(percent)}%`,
        color: percent === 0 ? '#8e8fb4' : good ? '#186c2d' : '#b21f2b',
        rising,
    }
}

export function percentChange(current, previous) {
    if (!previous || current === null || current === undefined) return null
    return Math.round(((current - previous) / previous) * 1000) / 10
}
